import React, { useRef, useEffect, useCallback } from 'react';

export interface AppAutoTextareaProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
  minHeight?: number;
  maxHeight?: number;
  disabled?: boolean;
}

const AppAutoTextarea: React.FunctionComponent<AppAutoTextareaProps> = ({
  value, onChange, className, placeholder, minHeight = 32, maxHeight, disabled
}) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const resize = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    let next = el.scrollHeight;
    if (maxHeight && next > maxHeight) {
      next = maxHeight;
      el.style.overflowY = 'auto';
    } else {
      el.style.overflowY = 'hidden';
    }
    el.style.height = `${Math.max(next, minHeight)}px`;
  }, [minHeight, maxHeight]);

  useEffect(() => { resize(); }, [value, resize]);

  return (
    <textarea
      ref={ref}
      className={className}
      rows={1}
      placeholder={placeholder}
      disabled={disabled}
      style={{ minHeight: `${minHeight}px`, overflowY: 'hidden', resize: 'none' }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default AppAutoTextarea;
